import { render } from "./PayPalCapture.vue?vue&type=template&id=2b1b2ae5"
import script from "./PayPalCapture.vue?vue&type=script&lang=js"
export * from "./PayPalCapture.vue?vue&type=script&lang=js"

import "./PayPalCapture.vue?vue&type=style&index=0&id=2b1b2ae5&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__